import { useMemo } from 'react'
import styled from 'styled-components'
import { useInView } from 'react-intersection-observer'
import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'
import type { OfferFlexibleCancellationTimelineContext } from 'components/Common/CancellationPolicies/Flash/getOfferFlexibleCancellationTimelineContext'
import OfferCancellationPolicyTimeline from './OfferCancellationPolicyTimeline'

const ActivationSentinel = styled.div`
  height: 1px;
  width: 100%;
`

interface Props {
  timelineContext: OfferFlexibleCancellationTimelineContext
}

/**
 * Offer-page cancellation timeline experiment content + activation.
 * Mount gating + USP dedupe live in useOfferFlashCancellationTimelineSurface (FlashHotelIntro).
 */
function OfferCancellationPolicyTimelineExperiment(props: Props) {
  const { timelineContext } = props

  const [timelineRef, timelineInView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
  })

  const experimentOptions = useMemo(() => ({
    canActivate: timelineInView,
  }), [timelineInView])

  const { isAnyVariant } = useExperiment(
    ChertoExperiments.croCancellationTimelineOnOfferPageV2,
    experimentOptions,
  )

  return (
    <div>
      <ActivationSentinel
        ref={timelineRef}
        data-testid="offer-cancellation-policy-timeline-activation-anchor"
      />
      {isAnyVariant && (
        <OfferCancellationPolicyTimeline
          details={timelineContext.details}
          isCharter={timelineContext.isCharter}
        />
      )}
    </div>
  )
}

export default OfferCancellationPolicyTimelineExperiment
